const states = [
  {
    value: 'BR-AC',
    text:  'Acre',
  },
  {
    value: 'BR-AL',
    text:  'Alagoas',
  },
  {
    value: 'BR-AP',
    text:  'Amapá',
  },
  {
    value: 'BR-AM',
    text:  'Amazonas',
  },
  {
    value: 'BR-BA',
    text:  'Bahia',
  },
  {
    value: 'BR-CE',
    text:  'Ceará',
  },
  {
    value: 'BR-DF',
    text:  'Distrito Federal',
  },
  {
    value: 'BR-ES',
    text:  'Espírito Santo',
  },
  {
    value: 'BR-GO',
    text:  'Goiás',
  },
  {
    value: 'BR-MA',
    text:  'Maranhão',
  },
  {
    value: 'BR-MT',
    text:  'Mato Grosso',
  },
  {
    value: 'BR-MS',
    text:  'Mato Grosso do Sul',
  },
  {
    value: 'BR-MG',
    text:  'Minas Gerais',
  },
  {
    value: 'BR-PA',
    text:  'Pará',
  },
  {
    value: 'BR-PB',
    text:  'Paraíba',
  },
  {
    value: 'BR-PR',
    text:  'Paraná',
  },
  {
    value: 'BR-PE',
    text:  'Pernambuco',
  },
  {
    value: 'BR-PI',
    text:  'Piauí',
  },
  {
    value: 'BR-RJ',
    text:  'Rio de Janeiro',
  },
  {
    value: 'BR-RN',
    text:  'Rio Grande do Norte',
  },
  {
    value: 'BR-RS',
    text:  'Rio Grande do Sul',
  },
  {
    value: 'BR-RO',
    text:  'Rondônia',
  },
  {
    value: 'BR-RR',
    text:  'Roraima',
  },
  {
    value: 'BR-SC',
    text:  'Santa Catarina',
  },
  {
    value: 'BR-SP',
    text:  'São Paulo',
  },
  {
    value: 'BR-SE',
    text:  'Sergipe',
  },
  {
    value: 'BR-TO',
    text:  'Tocantins',
  },
];
export default states;
